import { render, staticRenderFns } from "./UserManagementForm.vue?vue&type=template&id=a4b09b94&scoped=true&"
import script from "./UserManagementForm.vue?vue&type=script&lang=js&"
export * from "./UserManagementForm.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementForm.vue?vue&type=style&index=0&id=a4b09b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b09b94",
  null
  
)

export default component.exports
import {QCardSection,QSpinnerOval,QForm,QScrollArea,QInput,QSelect,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QSpinnerOval,QForm,QScrollArea,QInput,QSelect,QBtn})
